const EXPERTS = ["elina", "anna", "simona", "no_coach"]

// Brand-specific Premium upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
    chancePath,
    sendOffPath,
  } = {}) => ({
    // Init common upsell functionality
    ...commonUpsell({
      upsellOfferType: "chat",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      chancePath,
      sendOffPath,
    }),

    // Add or overwrite brand-specific functionality
    experts: EXPERTS,
    selectedExpert: EXPERTS[0],

    selectExpert(id) {
      this.store.internalTracker.trackClick({ clickName: "Expert Selected" })

      this.selectedExpert = this.experts[id - 1]

      this.store.values.selectedChatNutrionist = this.selectExpert
    },

    isExpertSelected(id) {
      return this.selectedExpert === this.experts[id - 1]
    },

    isExpertRecommended(id) {
      return id === 1
    },

    isNoExpert(id) {
      return this.experts[id - 1] === "no_coach"
    },

    async handlePurchase(isModal) {
      if (isModal) {
        this.store.values.selectedChatNutrionist = this.selectExpert
        this.purchase()

        return
      }

      // If no expert chosen - open chance modal screen
      if (this.selectedExpert === "no_coach") {
        this.goToChance()

        return
      }

      this.purchase()
    },
  })
